import { useTranslation } from "react-i18next";
import type { RoomState } from "../../api/generated/model";
import { Alert } from "../../design/primitives/Alert";
import styles from "./room.module.css";

export interface TeacherAntechamberProps {
  readonly room: RoomState;
  readonly denied?: boolean;
}

export function TeacherAntechamber({ room, denied }: TeacherAntechamberProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.stage}>
      <h2>{t("room.antechamberTitle")}</h2>
      {/*
        Rotulo e valor sao duas chamadas, e nao uma interpolacao. `room.captureState`
        vale "Estado da captura" nos tres catalogos e NAO tem `{{state}}`: a versao
        interpolada compilava, passava no teste e apagava justamente o dado que o
        professor precisa ver antes de decidir se entra.
      */}
      <p>
        {t("room.captureState")}
        {': '}
        {t('room.capture.' + room.captureState)}
      </p>
      {denied ? <Alert tone="error">{t("room.admissionDenied")}</Alert> : null}
      <p>{t("room.recordingNotice")}</p>
    </div>
  );
}
